export default class CreateReportingPeriodRequest {
    fiscalYear = 0;
    periodNumber = 0;
    label: string | null = null;
    startDate = '';
    endDate = '';
}
